<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商城</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
      <el-breadcrumb-item>历史版本</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-table
        v-if="!isMobile()"
        :data="list"
        v-loading="loading"
        stripe
        style="width: 100%"
      >
        <el-table-column align="left" label="创建人 / 创建时间" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.user.name || '导入创建' }}<br />{{
              $time(scope.row.created_at).format('YYYY-MM-DD HH:mm')
            }}
            <template v-if="scope.$index == 0">
              <br />
              <el-tag size="mini" tag="div">当前版本</el-tag>
            </template></template
          >
        </el-table-column>
        <el-table-column align="left" label="商品封面">
          <template slot-scope="scope">
            <div class="pointer" @click.prevent="showDetail(scope.row)">
              <auth-img
                tag="el-image"
                style="width: 60px; height: 60px"
                :src="scope.row.cover"
                fit="cover"
              ></auth-img>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" label="件号/替代件号" prop="part_number">
          <template slot-scope="scope">
            <div class="pointer" @click.prevent="showDetail(scope.row)">
              {{ scope.row.part_number }}
              <span class="text-info" v-if="scope.row.new_part_number"
                ><br />{{ scope.row.new_part_number }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="分类"
          prop="commodity_category.name"
        ></el-table-column>
        <el-table-column align="center" label="类型（产地）">
          <template slot-scope="scope">
            {{ scope.row.type == 1 ? '备件' : '服务' }}（{{
              scope.row.origin_place == 1 ? '国产' : '进口'
            }}）</template
          >
        </el-table-column>
        <el-table-column align="left" label="PH/PH描述" prop="ph">
          <template slot-scope="scope">
            {{ scope.row.ph }}
            <br />
            {{ scope.row.ph_desc }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="审批要求">
          <template slot-scope="scope">
            {{ scope.row.whether_approve == 1 ? '无' : '下单' }} /
            {{ scope.row.ec_approve == 1 ? '无' : 'EC' }}
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="单价" prop="price">
          <template slot-scope="scope">{{
            scope.row.price.toFixed(2)
          }}</template>
        </el-table-column> -->
        <el-table-column
          align="center"
          label="单价"
          prop="price"
          min-width="120px"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.price.toFixed(2) }}</div>
            <template v-if="scope.row.rank_price">
              <div
                v-for="(k, v) in DealerRanks"
                v-if="
                  parseInt(v) > 0 && scope.row.rank_price[parseInt(v) - 1] > 0
                "
              >
                <el-tag class="mr-5" size="mini">{{ k.slice(0, 2) }}</el-tag
                >{{ scope.row.rank_price[parseInt(v) - 1].toFixed(2) }}
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="描述"
          prop="description"
          min-width="200px"
        >
          <template slot-scope="scope"
            >{{ scope.row.description }} <br />
            {{ scope.row.description_zh }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <CommodityDetail
      :model="showItem"
      :show.sync="detailDialog"
    ></CommodityDetail>
  </div>
</template>

<script>
import { commodityVersionList } from '@/service/getData'
import { isMobile } from '../../../util'
import { DealerRanks } from '@/config/global.js'
import CommodityDetail from './detail.vue'

export default {
  components: {
    CommodityDetail,
  },
  data() {
    return {
      loading: false,
      DealerRanks,
      isMobile,
      list: [],
      commodityID: this.$route.query.commodity_id || 0,
      showItem: {},
      detailDialog: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let res = await commodityVersionList({ commodity_id: this.commodityID })

      if (res.code == 0) {
        this.list = res.data.list
        this.loading = false
      }
    },
    showDetail(item) {
      this.showItem = item
      this.detailDialog = true
    },
  },
}
</script>